module.exports = __webpack_public_path__ + "media/images/pdf-background-212a054ce0c4cbf756cfcd985c005f3e.png";